module.exports = __webpack_public_path__ + "img/btn_menu_ljsf_c.3eb620dd.png";